import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rbacApi } from '../../Api/superadminApicall';

//     try {
//       const response = await rbacApi.rolePermissions.assign(roleId, permissionId);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to assign permission to role');
//     }
//   }
// );

// export const fetchRolePermissions = createAsyncThunk(
//   'rolePermissions/fetchRolePermissions',
//   async (roleId, { rejectWithValue }) => {
//     try {
//       const response = await rbacApi.rolePermissions.getForRole(roleId);
//       return { roleId, data: response.data };
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch role permissions');
//     }
//   }
// );

// export const removePermissionFromRole = createAsyncThunk(
//   'rolePermissions/removePermission',
//   async ({ roleId, permissionId }, { rejectWithValue }) => {
//     try {
//       await rbacApi.rolePermissions.remove(roleId, permissionId);
//       return { roleId, permissionId };
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to remove permission from role');
//     }
//   }
// );

// export const checkPermission = createAsyncThunk(
//   'rolePermissions/checkPermission',
//   async ({ roleId, permission }, { rejectWithValue }) => {
//     try {
//       const response = await rbacApi.checkPermission(roleId, permission);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to check permission');
//     }
//   }
// );

// const initialState = {
//   rolePermissions: {}, // Key: roleId, Value: array of permissions
//   permissionChecks: {}, // Key: `${roleId}-${permission}`, Value: boolean result
//   loading: false,
//   error: null,
//   success: null,
//   currentRoleId: null
// };

// const roleassignedSlice = createSlice({
//   name: 'rolePermissions',
//   initialState,
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     clearSuccess: (state) => {
//       state.success = null;
//     },
//     resetState: (state) => {
//       state.rolePermissions = {};
//       state.permissionChecks = {};
//       state.loading = false;
//       state.error = null;
//       state.success = null;
//       state.currentRoleId = null;
//     },
//     setCurrentRole: (state, action) => {
//       state.currentRoleId = action.payload;
//     },
//     clearPermissionCheck: (state, action) => {
//       const key = action.payload;
//       if (state.permissionChecks[key]) {
//         delete state.permissionChecks[key];
//       }
//     }
//   },
//   extraReducers: (builder) => {
//     builder
//       // Assign permission to role
//       .addCase(assignPermissionToRole.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(assignPermissionToRole.fulfilled, (state, action) => {
//         state.loading = false;
//         const { roleId, permissionId } = action.meta.arg;
//         if (!state.rolePermissions[roleId]) {
//           state.rolePermissions[roleId] = [];
//         }
//         // Add the permission to the role's permissions if not already present
//         const permissionExists = state.rolePermissions[roleId].some(
//           p => p.id === permissionId || p.permission_id === permissionId
//         );
//         if (!permissionExists && action.payload.data) {
//           state.rolePermissions[roleId].push(action.payload.data);
//         }
//         state.success = 'Permission assigned to role successfully';
//       })
//       .addCase(assignPermissionToRole.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
      
//       // Fetch role permissions
//       .addCase(fetchRolePermissions.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchRolePermissions.fulfilled, (state, action) => {
//         state.loading = false;
//         const { roleId, data } = action.payload;
//         state.rolePermissions[roleId] = data.data?.permissions || [];
//         state.currentRoleId = roleId;
//         state.success = 'Role permissions fetched successfully';
//       })
//       .addCase(fetchRolePermissions.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
      
//       // Remove permission from role
//       .addCase(removePermissionFromRole.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(removePermissionFromRole.fulfilled, (state, action) => {
//         state.loading = false;
//         const { roleId, permissionId } = action.payload;
//         if (state.rolePermissions[roleId]) {
//           state.rolePermissions[roleId] = state.rolePermissions[roleId].filter(
//             permission => permission.id !== permissionId && permission.permission_id !== permissionId
//           );
//         }
//         state.success = 'Permission removed from role successfully';
//       })
//       .addCase(removePermissionFromRole.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
      
//       // Check permission
//       .addCase(checkPermission.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(checkPermission.fulfilled, (state, action) => {
//         state.loading = false;
//         const { roleId, permission } = action.meta.arg;
//         const key = `${roleId}-${permission}`;
//         state.permissionChecks[key] = action.payload.data?.hasPermission || false;
//       })
//       .addCase(checkPermission.rejected, (state, action) => {
//         state.loading = false;
//         const { roleId, permission } = action.meta.arg;
//         const key = `${roleId}-${permission}`;
//         state.permissionChecks[key] = false;
//         state.error = action.payload;
//       });
//   }
// });

// export const { 
//   clearError, 
//   clearSuccess, 
//   resetState, 
//   setCurrentRole, 
//   clearPermissionCheck 
// } = roleassignedSlice.actions;

// // Selectors
// export const selectRolePermissions = (roleId) => (state) => 
//   state.rolePermissions.rolePermissions[roleId] || [];

// export const selectPermissionCheck = (roleId, permission) => (state) => {
//   const key = `${roleId}-${permission}`;
//   return state.rolePermissions.permissionChecks[key];
// };
// Async thunks
export const assignPermissionToRole = createAsyncThunk(
  'rolePermissions/assignPermission',
  async ({ roleId, permissionId }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.rolePermissions.assign(roleId, permissionId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to assign permission to role');
    }
  }
);

export const assignPermissionsToRoleBulk = createAsyncThunk(
  'rolePermissions/assignPermissionsBulk',
  async ({ roleId, permissionIds, permission_values }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.rolePermissions.assignBulk(roleId, permissionIds, permission_values);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to assign permissions to role');
    }
  }
);

export const fetchRolePermissions = createAsyncThunk(
  'rolePermissions/fetchRolePermissions',
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await rbacApi.rolePermissions.getForRole(roleId);
      return { roleId, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch role permissions');
    }
  }
);

export const removePermissionFromRole = createAsyncThunk(
  'rolePermissions/removePermission',
  async ({ roleId, permissionId }, { rejectWithValue }) => {
    try {
      await rbacApi.rolePermissions.remove(roleId, permissionId);
      return { roleId, permissionId };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to remove permission from role');
    }
  }
);

export const checkPermission = createAsyncThunk(
  'rolePermissions/checkPermission',
  async ({ roleId, permission }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.checkPermission(roleId, permission);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to check permission');
    }
  }
);


const AssignedpermissionsSlice = createSlice({
    name: "rolePermissions",
    initialState: {
        Assignpermissiondata: [],
        Assignpermissionadd: [],
        // permissionupdate: [],
        loading: false,
        error: null,
        currentRoleId: null,
        rolePermissions: {},
    },
    reducers: {
        setCurrentRole: (state, action) => {
            state.currentRoleId = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        clearSuccess: (state) => {
            state.success = null;
        },
        resetState: (state) => {
            state.Assignpermissiondata = [];
            state.Assignpermissionadd = [];
            state.loading = false;
            state.error = null;
            state.currentRoleId = null;
            state.rolePermissions = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchRolePermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRolePermissions.fulfilled, (state, action) => {
                state.loading = false;
                state.Assignpermissiondata = action.payload;
                const { roleId, data } = action.payload;
                state.rolePermissions[roleId] = data.data?.permissions || [];
                state.currentRoleId = roleId;
            })
            .addCase(fetchRolePermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(assignPermissionToRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(assignPermissionToRole.fulfilled, (state, action) => {
                state.loading = false;
                state.Assignpermissionadd = action.payload;
            })
            .addCase(assignPermissionToRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(assignPermissionsToRoleBulk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(assignPermissionsToRoleBulk.fulfilled, (state, action) => {
                state.loading = false;
                state.Assignpermissionadd = action.payload;
            })
            .addCase(assignPermissionsToRoleBulk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(removePermissionFromRole.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(removePermissionFromRole.fulfilled, (state, action) => {
                state.loading = false;
                // Optionally update chatMessages if API returns updated messages
                // Otherwise, we'll refetch messages after sending
            })
            .addCase(removePermissionFromRole.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearSuccess, resetState, setCurrentRole } = AssignedpermissionsSlice.actions;

// Selectors
export const selectRolePermissions = (roleId) => (state) => 
  state.roleAssigned.rolePermissions[roleId] || [];

export default AssignedpermissionsSlice.reducer;